(() => {
  if (customElements.get('mxpro-cart-delivery')) return;
  const pending = new Map();
  const queue = [];
  let running = 0;

  function drain() {
    while (running < 4 && queue.length) {
      const job = queue.shift();
      running++;
      job.run().then(job.resolve, job.reject).finally(() => { running--; drain(); });
    }
  }

  function request(root, variantId) {
    const url = new URL(`${root.replace(/\/?$/, '/')}variants/${variantId}/`, location.origin);
    url.searchParams.set('section_id', 'mxpro-cart-delivery');
    if (url.origin !== location.origin || !/^\d+$/.test(variantId)) return Promise.reject(new Error('Invalid variant'));
    const key = url.href;
    if (pending.has(key)) return pending.get(key);
    const promise = new Promise((resolve, reject) => {
      queue.push({ resolve, reject, run: async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Availability unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = document.querySelector('[data-mxpro-dispatch-result]');
          if (!result || result.dataset.variantId !== variantId) throw new Error('Variant mismatch');
          return result.innerHTML;
        } finally { clearTimeout(timer); }
      } });
      drain();
    });
    pending.set(key, promise);
    promise.then(() => pending.delete(key), () => pending.delete(key));
    return promise;
  }

  customElements.define('mxpro-cart-delivery', class extends HTMLElement {
    connectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.querySelector('[data-dispatch-retry]')?.addEventListener('click', () => this.load());
      this.load();
    }

    disconnectedCallback() { this.generation++; }

    load() {
      const generation = this.generation;
      const retry = this.querySelector('[data-dispatch-retry]');
      if (retry) retry.hidden = true;
      this.setAttribute('aria-busy', 'true');
      request(this.dataset.rootUrl || '/', this.dataset.variantId || '').then(html => {
        if (!this.isConnected || this.generation !== generation) return;
        this.innerHTML = html;
        this.removeAttribute('aria-busy');
      }).catch(() => {
        if (!this.isConnected || this.generation !== generation) return;
        const message = this.querySelector('[data-dispatch-message]');
        if (message) message.textContent = this.dataset.errorMessage;
        if (retry) retry.hidden = false;
        this.removeAttribute('aria-busy');
      });
    }
  });
})();
